module.exports = __webpack_public_path__ + "static/media/3AA7D8_0_0.d69199f7.ttf";